<template>
  <!-- <v-card id="feature-items" class="elevation-0" outlined tile> -->
  <section style="height: 100%;">
    <v-navigation-drawer
      style="width:100%;"
      class="seller-menu"
      permanent
      :mini-variant="sellerMenuMini"
    >
      <v-list class="py-0">
        <v-list-item-group>
          <v-list-item @click="expandMenu">
            <span v-if="!sellerMenuMini">
              <v-icon>mdi-chevron-left</v-icon>Sembunyikan Menu
            </span>
            <span v-else>
              <v-icon>mdi-chevron-right</v-icon>
            </span>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar :size="sellerMenuMini ? 40 : 80">
            <v-img
              width="100%"
              :src="
                detailStore.store_image
                  ? detailStore.store_image
                  : '/assets/seller/default-toko.svg'
              "
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-title class="text-h6">{{ detailStore.store_name }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!sellerMenuMini">
          <v-list-item-content>
            <div class="d-flex justify-space-between">
              <span>Saldo Toko</span>
              <span>
                <router-link :to="'/seller/penghasilan-saya'">{{ saldo.total_balance |toRupiah }}</router-link>
              </span>
            </div>
            <hr v-if="showStockiestMenu" />
            <div v-if="showStockiestMenu" class="d-flex justify-space-between">
              <span>Saldo Reseller</span>

              <span>
                <router-link :to="'/seller/deposit-reseller'">{{ saldoDepositReseller |toRupiah }}</router-link>
              </span>
            </div>
            <!-- <hr /> -->
            <!-- <div class="d-flex justify-space-between">
              <span>Saldo Coin Gen</span>
              <span>
                <router-link :to="'/history-coin-gen'">{{ saldoCoinGen |toRupiah }}</router-link>
              </span>
            </div> -->

            <!-- <v-list-item-subtitle>{{ detailStore.store_description }}</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item link :to="items[0].to">
          <v-list-item-icon>
            <v-img width="10" :src="items[0].icon"></v-img>
          </v-list-item-icon>
          <v-list-item-title>{{ items[0].title }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="items[1].to">
          <v-list-item-icon>
            <v-img width="10" :src="items[1].icon"></v-img>
          </v-list-item-icon>
          <v-list-item-title>{{ items[1].title }}</v-list-item-title>
        </v-list-item>
        <template v-for="(item, idx) in items">
          <v-list-group :key="idx" v-if="idx > 1">
            <template #prependIcon>
              <v-img width="10" :src="item.icon"></v-img>
            </template>
            <template v-slot:activator>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>
            <template v-if="item.children.length > 0">
              <template v-for="child in item.children">
                <v-list-item v-if="child.show" :to="child.to" :key="child" link>
                  <!-- <v-list-item-icon>
                            <v-img width="10" :src="child.icon"></v-img>
                  </v-list-item-icon>-->
                  <v-list-item-title class="ms-5 ps-5">{{ child.title }}</v-list-item-title>
                </v-list-item>
              </template>
            </template>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <div class="d-none px-4 py-5">
      <v-expansion-panels
        tile
        multiple
        accordion
        v-model="panel"
        class="accordion-filter"
        v-if="userData"
      >
        <template v-for="(item, idx) in items">
          <template v-if="item.children.length === 0">
            <router-link
              :to="item.to"
              class="font-weight-bold text-body-2 px-2 feature-title single-link"
              :key="idx"
            >
              <v-img width="10" :src="item.icon"></v-img>
              {{ item.title }}
            </router-link>
          </template>
          <template v-else>
            <v-expansion-panel class="py-3" :key="idx">
              <v-expansion-panel-header class="font-weight-bold text-body-2 px-2 feature-title">
                <v-img width="10" :src="item.icon"></v-img>
                {{ item.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list class="py-2">
                  <template v-for="(sub, ids) in item.children">
                    <router-link
                      :to="{ path: sub.to }"
                      class="text-deco black--text"
                      :class="checkPermission(sub.title)"
                      :key="ids"
                      v-if="sub.show"
                    >
                      <v-list-item dense class="px-2 py-1 feature-item">
                        <v-list-item-title>{{ sub.title }}</v-list-item-title>
                      </v-list-item>
                    </router-link>
                  </template>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </template>
      </v-expansion-panels>
    </div>
  </section>
  <!-- </v-card> -->
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import auth from "@/helpers/auth";

const isStockist = () => {
  const user = auth.getUserData();
  if (user.user_is_stockist.toLowerCase() === "true") {
    return true;
  } else {
    return false;
  }
};
export default {
  name: "SellerSidebar",
  data: () => ({
    showMorecategory: false,
    panel: []
  }),

  computed: {
    showStockiestMenu() {
      let user = auth.getUserData();
      if (user.user_is_stockist.toLowerCase() === "true") {
        return true;
      } else {
        return false;
      }
    },
    ...mapState("cart", ["saldoCoinGen", "saldoDepositReseller"]),
    ...mapState("auth", ["isAuth", "userData"]),
    ...mapGetters("storeSeller", ["isStoreB2b"]),
    ...mapState("storeSeller", ["sellerMenuMini", "detailStore"]),
    ...mapState("saldoSeller", ["saldo"]),

    items() {
      let items = [
        {
          icon: "/assets/seller/dashboard.svg",
          title: "Dashboard",
          to: "/seller/dashboard",
          children: []
        },
        // {
        //   icon: "/assets/seller/pesanan.svg",
        //   title: "Pesanan",
        //   to: "/seller",
        //   children: [
        //     {
        //       title: "Pesanan Saya",
        //       to: "/seller/pesanan-saya",
        //       show: true
        //     }
        //   ]
        // },
        {
          icon: "/assets/seller/pesanan.svg",
          title: "Pesanan",
          to: "/seller/pesanan-saya",
          children: []
        },
        {
          icon: "/assets/seller/produk.svg",
          title: "Produk",
          to: "/seller",
          children: [
            {
              title: "Produk Saya",
              to: "/seller/produk-saya",
              show: true
            },
            {
              title: "Tambah Produk Baru",
              to: "/seller/tambah-produk",
              show: true
            },
            // {
            //   title: "Produk Reseller",
            //   to: "/seller/produk-eksklusif",
            //   show: isStockist() && !this.isStoreB2b
            // },
            {
              title: "Order Produk Reseller",
              to: "/seller/pembelian",
              show: isStockist() && !this.isStoreB2b
            }
          ]
        },
        {
          icon: "/assets/seller/penghasilanmu.svg",
          title: "Wallet",
          to: "/seller",
          children: [
            {
              title: "Saldo Toko",
              to: "/seller/penghasilan-saya",
              show: true
            },
            {
              title: "Saldo Reseller",
              to: "/seller/deposit-reseller",
              show: isStockist() && !this.isStoreB2b
            },
            {
              title: "Rekening Bank",
              to: "/seller/rekening-bank",
              show: true
            }
          ]
        },
        {
          icon: "/assets/seller/tentang-toko.svg",
          title: "Tentang Toko",
          to: "/seller",
          children: [
            {
              title: "Profil Toko",
              to: "/seller/profile-toko-v3",
              show: true
            }
          ]
        },
        {
          icon: "/assets/seller/pengaturan.svg",
          title: "Pengaturan",
          to: "/seller",
          children: [
            {
              title: "Kurir Pengiriman",
              to: "/seller/pengaturan-pengiriman",
              show: true
            },
            {
              title: "Daftar Alamat",
              to: "/profile?param=alamat_v2",
              show: true
            }
          ]
        }
      ];
      return items;
    }
  },

  methods: {
    ...mapActions("cart", ["getSaldoCoinGen", "getSaldoDepositReseller"]),
    ...mapActions("storeSeller", ["getStoreDetail", "changeSellerMenu"]),
    ...mapActions("saldoSeller", ["getSaldoSummary"]),

    gotoModule(link) {
      this.$router.push({ path: link });
    },
    expandMenu() {
      this.changeSellerMenu();
    },
    checkPermission(url) {
      const restrictUrl = ["Produk Eksklusif", "Order Produk Eksklusif"];
      const check = restrictUrl.filter(d => d === url);
      if (check.length && this.userData.user_type !== "stockist")
        return "d-none";
      else return "";
    }
  },
  created() {
    this.getSaldoCoinGen();
    this.getSaldoDepositReseller();
    this.getSaldoSummary();
  },

  mounted() {
    /*this.getStoreDetail()*/
  }
};
</script>

<style lang="scss" scoped>
#feature-items {
  height: 100vh;
  top: 90px;
  max-height: calc(100% - 0px);
  transform: translateX(0%);
  width: 260px;
  position: fixed;
  overflow-y: auto;
  padding-bottom: 15vh;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1),
    0px 8px 10px 1px rgba(0, 0, 0, 0.05), 0px 3px 14px 2px rgba(0, 0, 0, 0.05) !important;

  @media (max-width: 599px) {
    display: none !important;
  }

  .feature-title {
    padding-left: 45px !important;
    position: relative;
    text-transform: capitalize !important;

    .v-image {
      position: absolute;
      width: 36px !important;
      height: 36px;
      left: -2px;
    }

    &.single-link {
      padding: 21px 12px;
      display: flex;
      position: relative;
      width: 100%;
      flex-direction: column;
      justify-content: center;
      text-decoration: none;
      color: #333;
      border-top: 1px solid rgba(0, 0, 0, 0.12);

      &:first-child {
        border-top: 0;
      }

      &:hover,
      &focus {
        background: #f5f5f5 !important;
      }
    }
  }
  .feature-item {
    padding-left: 45px !important;
    position: relative;
    text-transform: capitalize !important;
  }
}
.seller-menu {
  border-top: 1px solid #e0e0e0;
}
</style>
